const getInstagramRegex = (): RegExp => /https:\/\/www.instagram.com\/p\/([^/]+)/

export default getInstagramRegex
